import Immutable from 'immutable';

import {
  NODE_DELETED,
  NODE_GET_LOADED,
} from '../../../actions/Entity/Node';

const initialState = Immutable.fromJS({});

export default function customNodeReducer(state = initialState, action = {}) {
  switch (action.type) {
    case NODE_GET_LOADED: {
      return state.set(action.node_id, Immutable.fromJS(action.data));
    }

    case NODE_DELETED: {
      return initialState;
    }

    default:
      return state;
  }
}
